<h1 mat-dialog-title>Delete Whole Day?</h1>

<mat-dialog-content class="max-w-screen-sm">
  Are you sure you want to remove all entries for Employee Hours, Equipment Hours and Production for the day
  <strong>{{ dateDisplay }}</strong
  >?
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button (click)="close(false)">No, Cancel</button>
  <button mat-raised-button color="warn" (click)="close(true)">Yes, Delete Day</button>
</mat-dialog-actions>
